export interface PopulationFilterSelector {
  value: string;
  transId: string;
}

export enum PopulationFilterValue {
  ALL = 'ALL',
  CUSTOM = 'CUSTOM'
}

export enum PopulationFilterTransId {
  ALL = 'CONTEXT_BAR.working_on_population_all',
  CUSTOM = 'CONTEXT_BAR.working_on_custom_population'
}
